document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    // let locationTap = document.querySelectorAll('.location-block');
    // let locationSlide = document.querySelectorAll('.location-slider');

    // if(locationSlide){

    //     const locationSlider = new Swiper('.location-slider', {
    //         /*Optional parameters*/
    //         loop: true,
    //         effect: "fade",
    //         fadeEffect: {
    //             "crossFade": true
    //         }
    //     });
    //     locationTap.forEach(function(hB,hBc) {
    //         let hNav = hB.querySelectorAll('.location-point');
    //         let textG = hB.querySelector('.copy-generic');
    //         let textS = hB.querySelector('.location-slider');
    //         hNav.forEach(function(h_nav) {
    //             let navCount = h_nav.dataset.nav;
    //             h_nav.addEventListener('click', function(e){
    //                 e.preventDefault();
    //                 if(locationTap.length > 1){
    //                     locationSlider[hBc].slideTo(navCount, 500);
    //                 } else {
    //                     locationSlider.slideTo(navCount, 500);
    //                 }
    //                 hNav.forEach(function(h_nav) {
    //                     h_nav.classList.remove('active');
    //                 });
    //                 this.classList.add('active');
    //                 if(!textG.classList.contains('close')){
    //                     textG.classList.add('close');
    //                     textS.classList.add('open');
    //                 }
    //             });
    //             if(locationTap.length > 1){
    //                 locationSlider[hBc].on('slideChange', function () {
    //                     hNav.forEach(function(h_nav) {
    //                         let navC = h_nav.dataset.nav;
    //                         h_nav.classList.remove('active');
    //                         if(locationSlider[hBc].realIndex == navC){
    //                             h_nav.classList.add('active');
    //                         }
    //                     });
    //                 });
    //             } else {
    //                 let navIn = 0;
    //                 locationSlider.on('slideChange', function () {
    //                     hNav.forEach(function(h_nav) {
    //                         let navC = h_nav.dataset.nav;
    //                         h_nav.classList.remove('active');
    //                         if(locationSlider.realIndex == navC && navIn != 0){
    //                             h_nav.classList.add('active');
    //                         }
    //                         navIn++;
    //                     });
    //                 });
    //             }
    //         });
    //     });
    // }

    let quoteSlider = new Swiper('.quote-swiper', {
        centeredSlides: true,
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        }
    });

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper('.gallery-slider', {
               
                loop: true,
                slidesPerView: 1.2,
                spaceBetween: 15,
                centeredSlides: true,
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                },
                breakpoints: {
                    640: {
                        effect: "fade",
                        fadeEffect: {
                            "crossFade": true
                        },
                        watchSlidesProgress: true,
                        spaceBetween: 30,
                        slidesPerView: 1
                    }
                }
            });
        });
    }


});